// src/pages/Private/Student/CourseView/LessonView.jsx
import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from '../../../../utils/axios';
import './LessonView.css';

function LessonView() {
  const { lessonId } = useParams();
  const navigate = useNavigate();
  const [lesson, setLesson] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showQuiz, setShowQuiz] = useState(false);
  const [quizAttempt, setQuizAttempt] = useState(null);

  useEffect(() => {
    loadLesson();
  }, [lessonId]);

  const loadLesson = async () => {
    try {
      const response = await axios.get(`/lessons/${lessonId}`);
      setLesson(response.data);
    } catch (error) {
      console.error('Ders yüklenirken hata:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCompleteLesson = async () => {
    try {
      await axios.post(`/progress/course/${lesson.course}/lesson/${lessonId}/complete`);
      // İlerleme güncellendi
    } catch (error) {
      console.error('Ders tamamlama hatası:', error);
    }
  };

  const handleStartQuiz = async () => {
    try {
      const response = await axios.post(`/quizzes/${lesson.quiz}/start`);
      setQuizAttempt(response.data);
      setShowQuiz(true);
    } catch (error) {
      console.error('Quiz başlatma hatası:', error);
    }
  };

  if (loading) return <div className="loading">Yükleniyor...</div>;

  return (
    <div className="lesson-view">
      <div className="lesson-navigation">
        <button className="btn-back" onClick={() => navigate(-1)}>← Kursa Dön</button>
      </div>

      <div className="lesson-content">
        <h1>{lesson?.title}</h1>
        <p className="lesson-description">{lesson?.description}</p>

        {lesson?.content?.videoUrl && (
          <div className="video-container">
            <video controls>
              <source src={lesson.content.videoUrl} type="video/mp4" />
              Tarayıcınız video etiketini desteklemiyor.
            </video>
          </div>
        )}

        {lesson?.content?.pdfUrl && (
          <div className="pdf-container">
            <a href={lesson.content.pdfUrl} target="_blank" rel="noopener noreferrer">
              📄 PDF'i İndir
            </a>
          </div>
        )}

        {lesson?.content?.resources?.length > 0 && (
          <div className="resources-section">
            <h3>Kaynaklar</h3>
            <ul>
              {lesson.content.resources.map((resource, index) => (
                <li key={index}>
                  <a href={resource.url} target="_blank" rel="noopener noreferrer">
                    {resource.title || resource.url}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        )}

        {lesson?.quiz && !showQuiz && (
          <div className="quiz-section">
            <h3>Quiz</h3>
            <button className="btn-quiz" onClick={handleStartQuiz}>
              Quiz'i Başlat
            </button>
          </div>
        )}

        {lesson?.assignment && (
          <div className="assignment-section">
            <h3>Ödev</h3>
            <button 
              className="btn-assignment"
              onClick={() => navigate(`/student/assignment/${lesson.assignment}`)}
            >
              Ödevi Görüntüle
            </button>
          </div>
        )}

        <div className="lesson-actions">
          <button className="btn-complete" onClick={handleCompleteLesson}>
            Dersi Tamamla
          </button>
        </div>
      </div>
    </div>
  );
}

export default LessonView;